import { MfrmModal } from '~/components/mfrm-modal';
import Tabs from './tabs';

type FinancingOffer = {
  index: number;
  name: string;
  url: string;
};

type LowerCaseTypes = {
  synchrony: string;
  progresive: string;
  affirm: string;
};

interface DrawerProps {
  isOpen: boolean | false;
  setIsOpen: (isOpen: boolean) => void;
  filteredOffers: FinancingOffer[];
  lowerCaseTypes: LowerCaseTypes;
  activeTab: number;
  setActiveTab: (activeTab: number) => void;
  syfTabBody?: React.ReactNode;
  progressiveTotalAmount?: number;
  balanceAmount?: number;
}

const SideDrawer: React.FC<DrawerProps> = ({
  isOpen,
  setIsOpen,
  filteredOffers,
  lowerCaseTypes,
  activeTab,
  setActiveTab,
  syfTabBody,
  progressiveTotalAmount,
  balanceAmount,
}) => {
  const modalBody = (
    <Tabs
      filteredOffers={filteredOffers}
      lowerCaseTypes={lowerCaseTypes}
      activeTab={activeTab}
      setActiveTab={setActiveTab}
      syfTabBody={syfTabBody}
      progressiveTotalAmount={progressiveTotalAmount}
      balanceAmount={balanceAmount}
    />
  );
  return (
    <MfrmModal
      isOpen={isOpen}
      toggleModal={() => setIsOpen(!isOpen)}
      headerTitle="Financing & Leasing Options"
      modalBody={modalBody}
    />
  );
};

export default SideDrawer;
